__turbopack_context__.v({
  "ArticlePage": "yZ6HXa_ArticlePage",
  "ArticlePage__Breadcrumbs": "yZ6HXa_ArticlePage__Breadcrumbs",
  "ArticlePage__Container": "yZ6HXa_ArticlePage__Container",
  "ArticlePage__Content": "yZ6HXa_ArticlePage__Content",
  "ArticlePage__ContentWrap": "yZ6HXa_ArticlePage__ContentWrap",
  "ArticlePage__Form": "yZ6HXa_ArticlePage__Form",
  "ArticlePage__Image": "yZ6HXa_ArticlePage__Image",
  "ArticlePage__ImageCaption": "yZ6HXa_ArticlePage__ImageCaption",
  "ArticlePage__ImageWrap": "yZ6HXa_ArticlePage__ImageWrap",
  "ArticlePage__MobileNavigation": "yZ6HXa_ArticlePage__MobileNavigation",
  "ArticlePage__Preamble": "yZ6HXa_ArticlePage__Preamble",
  "ArticlePage__Published": "yZ6HXa_ArticlePage__Published",
  "ArticlePage__Sidebar": "yZ6HXa_ArticlePage__Sidebar",
  "ArticlePage__SidebarItem": "yZ6HXa_ArticlePage__SidebarItem",
  "ArticlePage__SidebarItem--Desktop": "yZ6HXa_ArticlePage__SidebarItem--Desktop",
  "ArticlePage__Text": "yZ6HXa_ArticlePage__Text",
  "ArticlePage__Title": "yZ6HXa_ArticlePage__Title",
  "ArticlePage__Wrap": "yZ6HXa_ArticlePage__Wrap",
});
